import { Pipe, PipeTransform } from '@angular/core';
import {SharedDataService } from './shared-data.service'
@Pipe({
  name: 'userIdMapping'
})

export class UserIdMappingPipe implements PipeTransform {
  constructor(
    public sharedDataservice:SharedDataService
  ){}
  public readonly userMapping=[...JSON.parse(!this.sharedDataservice.apiusersNames?'[]':this.sharedDataservice.apiusersNames)]
  transform(value: any, args?: any): any {
    let FullName
    const finderPath=this.userMapping.find(item=>item.User_Identifier==value)
    if(finderPath){
      if(args=='full'){
        FullName=finderPath.First_Name+(finderPath.Middle_Name?" "+finderPath.Middle_Name:'')+" "+finderPath.Last_Name
      }else if(args=='short'){
        FullName=finderPath.First_Name+" "+finderPath.Last_Name
      }else{
        FullName=finderPath.First_Name+" "+finderPath.Last_Name
      }
    }

    return finderPath?FullName:value;
  }

}



// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/user-id-mapping.pipe.ts